import { useAppDispatch } from "src/utils/ReduxHooks";
import { useI18n } from "components/lni18n";
import useTypedSelector from "utils/useTypedSelector";
import { imagePickerDuck } from "./ImagePickerDuck";
import ImageList from "./ImageList";
import SelectedImage from "./SelectedImage"
import ImageUpload from "./ImageUpload";
import ImageExternUrl from "./ImageExternUrl";
import { endPoint } from "src/AppConstants"

/**
 * 
 * @param {{onSubmit: Function}} props
 */
const ImagePicker = ({ onSubmit }) => {
    /** @type {import('redux').Dispatch<any>} */
    const dispatch = useAppDispatch();
    const { languageService: t } = useI18n();
    const { filteredImages, imageData, tab, selectedImage } = useTypedSelector(state => state.imagepicker);
    const { user: currentUser } = useTypedSelector(state => state.login);

    if (!imageData) {
        return null;
    }
    /**
     * 
     * @param {'browse' | 'selected' | 'web' | 'upload'} tab 
     */
    const setTab = (tab) => {
        dispatch(imagePickerDuck.setTab(tab));
    }


    let menuItems = [
        <button className={tab === "browse" ? "active" : ""} key="browse" onClick={() => setTab("browse")} >
            {t.getText("browse")}
        </button>,


        <button className={tab === "web" ? "active" : ""} key="web" onClick={() => setTab("web")} >
            {t.getText("url")}
        </button>,

        <button className={tab === "upload" ? "active" : ""} key="upload" onClick={() => setTab("upload")} >
            {t.getText("addpict")}
        </button>,

        <button disabled={selectedImage === null} className={tab === "selected" ? "active" : ""} key="selected" onClick={() => setTab("selected")} >
            {t.getText("insertimage")}
        </button>


    ];


    const setSelectedImage = (id) => {
        dispatch(imagePickerDuck.setCurrentImage(null));
        dispatch(imagePickerDuck.setSelectedImage(id));
        dispatch(imagePickerDuck.getImageInfo(id, currentUser.Id));
        dispatch(imagePickerDuck.setTab('selected'));
    }

    const handleUserChange = (event) => {
        dispatch(imagePickerDuck.setSelectedUser(event.target.value));
    }

    /**
     * 
     * @param {{ imageAlign: string, selectedImage: string | null, selectedUrl: string | null }} data 
     */
    const onSubmitImage = (data) => {
        let imageData = {
            imageAlign: data.imageAlign,
            imageId: data.selectedImage
        }
        if (data.selectedImage) {
            imageData.url = endPoint.GET_IMAGE_URL(data.selectedImage);
        } else if (data.selectedUrl) {
            imageData.url = endPoint.GET_IMAGE_PROXY_URL(data.selectedUrl);
        }
        else {
            throw new Error("no image at all...!");
        }

        onSubmit(imageData);
    }

    return <div>
        <div className="custom-tab-heading-list">
            {menuItems}
        </div>


        <div className={`mt-4 ${tab !== 'browse' ? "off-screen" : ""}`} >

            <select className="col-12 col-sm-6  form-control" id="classSelect" defaultValue={currentUser.Id} onChange={(e) => handleUserChange(e)}>
                <option key={'mine'} value={currentUser.Id}>{t.getText("images.mine")}</option>
                <option disabled>------------</option>
                <option key={'all'} value={""}>{t.getText("images.all")}</option>
                <option disabled>------------</option>
                {imageData.Users.map((u) => {
                    return (
                        <option key={u.Id} value={u.Id}>{u.FullName}</option>
                    )
                })}
            </select>


            <ImageList images={filteredImages} onClick={setSelectedImage} />
        </div>


        <div className={tab !== 'selected' ? "off-screen" : ""}><SelectedImage onSubmit={onSubmitImage} /> </div>
        <div className={tab !== 'upload' ? "off-screen" : ""}><ImageUpload /></div>
        <div className={tab !== 'web' ? "off-screen" : ""}><ImageExternUrl onSubmit={onSubmitImage} /></div>





    </div>
}

export default ImagePicker;
